import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CommunityUpdateListLayer from "../components/CommunityUpdateListLayer";

const CommunityUpdatePage = () => {
    return (
        <MasterLayout>
            <CommunityUpdateListLayer />
        </MasterLayout>
    );
};

export default CommunityUpdatePage;
